/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/Columns.scss';

class Columns extends React.Component {
  static propTypes = {
    divided: React.PropTypes.bool,
  };

  static defaultProps = {
    divided: false,
  };

  render() {
    const children = React.Children.map(this.props.children, (child, index) => {
      return React.cloneElement(child, {
        key: index,
        className: cx('Columns-column', child.props.className, {
          'Columns-column-divided': this.props.divided,
        }),
      });
    });

    return (
      <div className={cx('Columns', this.props.className)}>
        {children}
      </div>
    );
  }
}

export default Columns;



// WEBPACK FOOTER //
// ./src/components/Columns.jsx